{
    "NAME": "ProtokollierungseinstellungenSprache",
    "LoggingSettings_Column_Component": "Komponente",
    "LoggingSettings_Column_Enabled": "Ermöglicht",
    "LoggingSettings_Column_BackupLogs": "Sicherungsprotokolle",
    "LoggingSettings_Column_Level": "Ebene",
    "LoggingSettings_Column_RollOverFiles": "Rollover-Dateien",
    "LoggingSettings_Column_MaxFileSizeAsMB": "Maximale Dateigröße (MB)",
    "LoggingSettings_Component_MainServlet": "Haupt-Servlet",
    "LoggingSettings_Component_Database": "Datenbank",
    "LoggingSettings_Component_Repository": "Repository",
    "LoggingSettings_Component_RptExecMgr": "Berichtsausführungsmanager",
    "LoggingSettings_Component_MailController": "Mail-Controller",
    "LoggingSettings_Component_TaskDelegator": "Aufgabendelegator",
    "LoggingSettings_Component_TelephoneModule": "Telefonmodul",
    "LoggingSettings_Component_OmniModule": "Omnichannel-Modul",
    "LoggingSettings_Action_Save": "Speichern",
    "LoggingSettings_Action_Cancel": "Stornieren",
    "LoggingSettings_Action_Refresh": "Aktualisieren",
    "LoggingSettings_ReadOnlyWarning": "Sie verfügen nicht über globale Administratorrechte, um die Protokollierungseinstellungen zu aktualisieren.",
    "LoggingSettings_SaveSuccess": "Die Protokollierungseinstellungen wurden gespeichert.",
    "LoggingSettings_SaveError": "Die Protokollierungseinstellungen konnten nicht gespeichert werden.",
    "LoggingSettings_RefreshConfirmTitle": "Nicht gespeicherte Änderungen verwerfen?",
    "LoggingSettings_RefreshConfirmBody": "Durch das Aktualisieren werden Ihre nicht gespeicherten Änderungen verworfen. Fortfahren?",
    "LoggingSettings_Empty": "Es sind keine Protokollierungseinstellungen verfügbar."
}